// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as AuthStore$PorterinFeature from "../../../domain/store/AuthStore.mjs";
import * as EventsTrackerHelper$PorterinFeature from "../../../../../shared/core/helpers/EventsTrackerHelper.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../../shared/core/helpers/PublishEventsHelper.mjs";
import * as AuthButtonV2ModuleScss from "../../styles/AuthButtonV2.module.scss";
import * as FareEstimateAnalyticsHelper$PorterinFeature from "../../../../fare-estimate-v1/domain/helpers/FareEstimateAnalyticsHelper.mjs";

var styles = AuthButtonV2ModuleScss;

function AuthButtonCmpV2(Props) {
  var is_disabled = Props.is_disabled;
  var is_submittingOpt = Props.is_submitting;
  var class_name = Props.class_name;
  var event_name = Props.event_name;
  var category = Props.category;
  var submit_text = Props.submit_text;
  var click_handlerOpt = Props.click_handler;
  var event_label = Props.event_label;
  var mobileOpt = Props.mobile;
  var is_submitting = is_submittingOpt !== undefined ? is_submittingOpt : false;
  click_handlerOpt !== undefined ? Caml_option.valFromOption(click_handlerOpt) : undefined;
  var mobile = mobileOpt !== undefined ? mobileOpt : "";
  return React.createElement("button", {
              className: "" + styles.submit + " " + (
                is_disabled ? styles["submit-disabled"] : styles["submit-enabled"]
              ) + " " + (
                is_submitting ? styles["submit-loading"] : ""
              ) + " " + class_name + "",
              disabled: is_disabled,
              onClick: (function (param) {
                  PublishEventsHelper$PorterinFeature.publishEvents(category, event_name, event_label);
                  EventsTrackerHelper$PorterinFeature.publishEventParameter(AuthStore$PorterinFeature.Signup.ga_signup_cta, {
                        fe_loginsignup_cta_confirm_tap: event_label
                      });
                  EventsTrackerHelper$PorterinFeature.publishEventParameter(AuthStore$PorterinFeature.Signup.moe_signup_cta_parameter, FareEstimateAnalyticsHelper$PorterinFeature.getFareSelectedCardVersionEventPayload(mobile));
                })
            }, is_disabled && is_submitting ? React.createElement("div", {
                    className: styles.loading
                  }) : React.createElement("p", {
                    className: styles["submit-text"]
                  }, submit_text));
}

var make = AuthButtonCmpV2;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
